import { render } from "./SigninPage.vue?vue&type=template&id=03a7deaa"
import script from "./SigninPage.vue?vue&type=script&lang=js"
export * from "./SigninPage.vue?vue&type=script&lang=js"
script.render = render

export default script